// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vendor-orders-container {
  height: 100vh;
  background-size: cover;
  height: 100vh;
  font-family: "Inter";
  color: black;
  gap: 5rem;
  display: flex;
  flex-direction: column;
  gap: 4rem;
  overflow: scroll;
}

.vendor-view-orders-card {
  font-size: 1.4rem;
  display: flex;
  margin: 2rem;
  padding: 1.5rem;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  background-color: #e5e7ebe2;
  display: flex;
  gap: 2rem;
  align-items: center;
}

.hidden {
  display: none;
}

.modal-invoice {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
}

.modal-content-invoice {
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  height: 99%;
  width: 99%;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  overflow: scroll;
  z-index: 100;
}

.close {
  position: absolute;
  top: 10px;
  right: 15px;
  font-size: 30px;
  cursor: pointer;
}

.status-circle {
  height: 2rem;
  width: 2rem;
  border: 0.5px solid black;
  border-radius: 500px;
  background-color: #008700;
}

.status-container {
  display: flex;
  gap: 1rem;
  justify-content: center;
  align-items: center;
}

@media (max-width: 910px) {
  .vendor-view-orders-card {
    font-size: 1.2rem;
  }
}

@media (max-width: 841px) {
  .vendor-view-orders-card {
    flex-direction: column;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/VendorOrders/VendorOrders.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,oBAAoB;EACpB,YAAY;EACZ,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,wCAAwC;EACxC,2BAA2B;EAC3B,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,uCAAuC;EACvC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".vendor-orders-container {\n  height: 100vh;\n  background-size: cover;\n  height: 100vh;\n  font-family: \"Inter\";\n  color: black;\n  gap: 5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 4rem;\n  overflow: scroll;\n}\n\n.vendor-view-orders-card {\n  font-size: 1.4rem;\n  display: flex;\n  margin: 2rem;\n  padding: 1.5rem;\n  border-radius: 5px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n  background-color: #e5e7ebe2;\n  display: flex;\n  gap: 2rem;\n  align-items: center;\n}\n\n.hidden {\n  display: none;\n}\n\n.modal-invoice {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 100;\n}\n\n.modal-content-invoice {\n  background-color: #fff;\n  padding: 20px;\n  border-radius: 8px;\n  height: 99%;\n  width: 99%;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  overflow: scroll;\n  z-index: 100;\n}\n\n.close {\n  position: absolute;\n  top: 10px;\n  right: 15px;\n  font-size: 30px;\n  cursor: pointer;\n}\n\n.status-circle {\n  height: 2rem;\n  width: 2rem;\n  border: 0.5px solid black;\n  border-radius: 500px;\n  background-color: #008700;\n}\n\n.status-container {\n  display: flex;\n  gap: 1rem;\n  justify-content: center;\n  align-items: center;\n}\n\n@media (max-width: 910px) {\n  .vendor-view-orders-card {\n    font-size: 1.2rem;\n  }\n}\n\n@media (max-width: 841px) {\n  .vendor-view-orders-card {\n    flex-direction: column;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
